import { IPoi } from './../../core/poi/poi.model';
import { Component, OnInit, ChangeDetectorRef, AfterViewChecked, OnDestroy, SecurityContext, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title, DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { select } from '@angular-redux/store';
import { Observable, of } from 'rxjs';
import { BreadcrumbService } from 'angular-crumbs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Itin } from '../../core/itinerari/itinerari.model';
import { ItinActionService } from '../../core/itinerari/itinerari.action';
import { ThemePalette } from '@angular/material/core';
import { Orientation } from '@ngmodule/material-carousel';
import { BreakpointObserver } from '@angular/cdk/layout';
import { environment } from 'src/environments/environment';
import { Poi } from 'src/app/core/poi/poi.model';
import { Attachments } from 'src/app/core/attachments/attachments.model';
import { ApiService } from 'src/app/services/api.service';
import { catchError, first, switchMap, tap } from 'rxjs/operators';
import * as pdfmake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { Lightbox } from 'ngx-lightbox';

@Component({
  selector: 'app-single-itinerary-page',
  templateUrl: './single-itinerary-page.component.html',
  styleUrls: ['./single-itinerary-page.component.scss']
})
export class SingleItineraryPageComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  @ViewChild('map', {static: false}) mapElement: ElementRef;

  geopos_url = {
    'Cimbri dell\'Altopiano dei Sette Comuni': 'cimbri',
    'Friulani in Veneto': 'friuli',
    'Italiani in Slovenia': 'italiani-in-slovenia',
    'Ladini del Comelico': 'ladini',
    'Sloveni in Italia': 'sloveni-in-italia',
    'Friulani in Friuli Venezia Giulia': 'friuli-fvg',
  };

  geopos_color = {
    'Cimbri dell\'Altopiano dei Sette Comuni': 'blue',
    'Friulani in Veneto': 'green',
    'Italiani in Slovenia': 'orange',
    'Ladini del Comelico': 'red',
    'Sloveni in Italia': 'lime',
    'Friulani in Friuli Venezia Giulia': 'blue_green',
  };

  titleAudioPlaying = false;
  attachmentAudioPlaying: number = null;

  @select(['itin', 'current'])
  itin_current$: Observable<Itin>;
  itin_current: Itin;
  subscription = [];
  current_lang = 'it';

  public parentHeight = 'auto';
  public timings = '250ms ease-in';
  public autoplay = true;
  public interval = 5000;
  public loop = true;
  public hideArrows = false;
  public hideIndicators = false;
  public color: ThemePalette = 'primary';
  public maxWidth = 'auto';
  public maintainAspectRatio = false;
  public proportion = 25;
  public slideHeight = '400px';
  public slides = 1;
  public overlayColor = 'rgba(255, 255, 255, 0.6)';
  public hideOverlay = true;
  public useKeyboard = true;
  public useMouseWheel = false;
  public orientation: Orientation = 'ltr';
  public log: string[] = [];
  exist_images = false;
  staticMapSrc = '';
  staticMapSrcBigScreen = '';
  staticMapSrcSmallScreen = '';
  loading = false;

  activeInfowindow: google.maps.InfoWindow;

  album: {src: string, caption: string, thumb: string}[] = [];

  googlePoiLinkText: string = '';
  googleItinLinkText: string = '';
  poiLinkText: string = '';
  areaLinkText: string = '';

  pdfPrimisText: string = '';
  pdfGeoposText: string = '';
  pdfThemPathsText: string = '';
  pdfContainsText: string = '';

  videos: SafeResourceUrl[] = [];

  audio: HTMLAudioElement;

  constructor(private titleService: Title,
              private route: Router,
              private activateroute: ActivatedRoute,
              private itinAction: ItinActionService,
              private breadcrumbservice: BreadcrumbService,
              private translate: TranslateService,
              private breakpointObserver: BreakpointObserver,
              private cdRef: ChangeDetectorRef,
              private sanitizer: DomSanitizer,
              private apiService: ApiService,
              private lightbox: Lightbox) {
    this.translate.setDefaultLang('it');
    if (this.translate.currentLang) {
      this.current_lang = this.translate.currentLang;
      this.translate.use(this.current_lang);
    } else {
      this.translate.use('it');
      this.current_lang = this.translate.currentLang;
    }
    this.translate.get('breadcrumb.single_itin').subscribe((res: string) => {
      this.titleService.setTitle(res + ' - PRIMIS');
    });
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.changeLangFunction();
    });
  }

  ngOnInit(): void {
    this.subscription.push(
      this.itin_current$.subscribe( itin => {
        this.itin_current = itin;
        if (!!this.itin_current) {
          this.changeLangFunction();
          if (this.checkAttachments(this.itin_current.attachments, 'picture')) {
            const pictures = this.singleTypeAttachments(this.itin_current.attachments, 'picture');
            this.slides = pictures.length;
            this.album = pictures.map(({file_byte}) => ({
              src: file_byte,
              caption: null,
              thumb: null
            }));
            this.exist_images = true;
          } else {
            this.hideArrows = true;
          }
          if (this.checkYoutubeVideo(this.itin_current.attachments)) {
            this.videos = this.youtubeVideos(this.itin_current.attachments).map(({file_byte}) =>
              this.sanitizer.bypassSecurityTrustResourceUrl(file_byte)
            );
          }
        }
      }),
      this.breakpointObserver.observe('(max-width: 500px)').subscribe(result => {
        if (result.matches) {
          this.staticMapSrc = this.staticMapSrcSmallScreen;
          this.slideHeight = '300px';
          this.hideIndicators = true;
        } else {
          this.staticMapSrc = this.staticMapSrcBigScreen;
          this.slideHeight = '450px';
          this.hideIndicators = false;
        }
      }),
    );
  }

  private mapInitializer(): void {
    const directionsRenderer = new google.maps.DirectionsRenderer({
      suppressMarkers: true
    });
    const map = new google.maps.Map(this.mapElement.nativeElement);
    directionsRenderer.setMap(map);

    const color = this.geopos_color[this.itin_current.geopos[0].name.it];
    const markerUrl = environment.mainUrl + `/assets/map/markerPrimis_${color}.png`;

    const geoposUrl = this.geopos_url[this.itin_current.geopos[0].name.it];

    const start: IPoi = this.itin_current.pois[0];
    const destination: IPoi = this.itin_current.pois[this.itin_current.pois.length - 1];
    const waypoints: IPoi[] = this.itin_current.pois.length > 2 ?
      this.itin_current.pois.slice(1, this.itin_current.pois.length - 1) :
      [];

    const pointsForMarkers: IPoi[] = [
      start,
      ...waypoints,
      destination
    ];
    let googleMapsItinUrl = `https://www.google.com/maps/dir/?api=1&` +
      `origin=${start.coords.lat},${start.coords.lon}&` +
      `destination=${destination.coords.lat},${destination.coords.lon}`;
    if (waypoints.length > 0) {
      const waypointsString = waypoints.map(({coords}) => `${coords.lat},${coords.lon}`).join('|');
      googleMapsItinUrl += `&waypoints=${waypointsString}`;
    }
    pointsForMarkers.forEach((poi: IPoi) => {
      const {id, poi_name, coords} = poi;
      const lat = coords.lat;
      const lng = coords.lon;

      const marker = new google.maps.Marker({
        position: {
          lat,
          lng,
        },
        map,
        icon: markerUrl,
        title: poi[this.current_lang],
      });

      const googleMapsPOIUrl = `http://maps.google.com/maps?z=11&q=loc:${lat}+${lng}`;
      const poiUrl = `${environment.mainUrl}/home/poi/${id}`;
      const areaUrl = `${environment.mainUrl}/home/aree/${geoposUrl}`;
      const contentString =
        '<div id="content">' +
        '<div id="siteNotice"></div>' +
        '<h3 id="firstHeading" class="firstHeading">' + poi_name[this.current_lang] + '</h3>' +
        '<div id="bodyContent">' +
        '<p><a href="' + googleMapsPOIUrl + '" target="blank">' + this.googlePoiLinkText + '</a></p>' +
        '<p><a href="' + googleMapsItinUrl + '" target="blank">' + this.googleItinLinkText + '</a></p>' +
        '<p><a href="' + poiUrl + '">' + this.poiLinkText + '</a></p>' +
        '<p><a href="' + areaUrl + '">' + this.areaLinkText + '</a></p>' +
        '</div>' +
        '</div>';
      const infowindow = new google.maps.InfoWindow({
        content: contentString,
      });

      marker.addListener('click', () => {
        if (!!this.activeInfowindow) {
          this.activeInfowindow.close();
        }
        infowindow.open(map, marker);
        this.activeInfowindow = infowindow;
      });
    });

    const waypts: google.maps.DirectionsWaypoint[] = [];
    waypoints.forEach((poi) => {
      waypts.push({
        location: new google.maps.LatLng(poi.coords.lat, poi.coords.lon),
        stopover: true,
      });
    });
    const directionsRequest: google.maps.DirectionsRequest = {
      origin: new google.maps.LatLng(start.coords.lat, start.coords.lon),
      destination: new google.maps.LatLng(destination.coords.lat, destination.coords.lon),
      waypoints: waypts,
      optimizeWaypoints: true,
      travelMode: google.maps.TravelMode.DRIVING,
    };

    const directionsService = new google.maps.DirectionsService();
    directionsService.route(
      directionsRequest,
      (response, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        directionsRenderer.setDirections(response);
      } else {
        console.error('Directions request failed due to ' + status);
      }
    });
  }

  ngAfterViewInit(): void {
    this.mapInitializer();
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.itinAction.setItinCurrent(null);
    this.subscription.forEach(x => x.unsubscribe());
    if (!!this.audio && (this.titleAudioPlaying || !!this.attachmentAudioPlaying)) {
      this.resetAudioPlaying();
    }
  }

  checkAttachments(att_list: Attachments[], att_type: string, source_needed: boolean = false) {
    if (source_needed) {
      return att_list.some(({file_type, source}) => file_type === att_type && !!source);
    }
    return att_list.some(({file_type}) => file_type === att_type);
  }

  checkYoutubeVideo(att_list: Attachments[]) {
    return att_list.some(({file_type, source}) => file_type === 'video' && !source);
  }

  checkIfAttachments(att_list: Attachments[]) {
    return att_list.some(({file_type}) => file_type !== 'picture');
  }

  singleTypeAttachments(att_list: Attachments[], att_type: string, source_needed: boolean = false) {
    if (source_needed) {
      return att_list.filter(({file_type, source}) => file_type === att_type && !!source);
    }
    return att_list.filter(({file_type}) => file_type === att_type);
  }

  youtubeVideos(att_list: Attachments[]) {
    return att_list.filter(({file_type, source}) => file_type === 'video' && !source);
  }

  routerFunction(geopos_array) {
    let new_route = this.geopos_url[geopos_array[0].name.it];
    this.route.navigate(['/home/aree/' + new_route]);
  }

  openImage(albumIdx: number) {
    this.lightbox.open(this.album, albumIdx);
  }

  downloadAtt(att_dict: Attachments) {
    if (!!att_dict.file_byte) {
      if (att_dict.file_type === 'audio') {
        this.playAudio(att_dict.file_byte);
      } else {
        this.getDownloadableAtt(att_dict.file_byte, att_dict.name);
      }
    } else {
      this.loading = true;
      this.apiService.getAttachment(att_dict.id).pipe(
        tap((fileByte: string) => {
          this.loading = false;
          if (att_dict.file_type === 'audio') {
            this.playAudio(fileByte);
          } else {
            this.getDownloadableAtt(fileByte, att_dict.name);
          }
        }),
        catchError((err) => {
          this.loading = false;
          console.error('Non è stato possibile recuperare l\'URL dell\'allegato richiesto');
          return of(err);
        })
      ).subscribe();
    }
  }

  getDownloadableAtt(base64File: string, fileName: string) {
    const arr = base64File.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    let new_blob = new Blob([u8arr], {type: mime});
    this.downloadFromBlob(new_blob, fileName);
  }

  downloadFromBlob(blobFile: Blob, fileName: string) {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute(
      'href',
      this.sanitizer.sanitize(
        SecurityContext.URL,
        this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blobFile))
      )
    );
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  changeLangFunction(): void {
    this.current_lang = this.translate.currentLang;
    this.titleService.setTitle(this.itin_current.itin_name[this.current_lang] + ' - PRIMIS');
    this.breadcrumbservice.changeBreadcrumb(this.activateroute.snapshot, this.itin_current.itin_name[this.current_lang]);
    this.translate.get('single_itin.google_maps_poi_link').pipe(
      first(),
      switchMap((res: string) => {
        this.googlePoiLinkText = res;
        return this.translate.get('single_itin.google_maps_itin_link').pipe(first());
      }),
      switchMap((res: string) => {
        this.googleItinLinkText = res;
        return this.translate.get('single_itin.poi_link').pipe(first());
      }),
      switchMap((res: string) => {
        this.poiLinkText = res;
        return this.translate.get('single_itin.area_link').pipe(first());
      }),
      switchMap((res: string) => {
        this.areaLinkText = res;
        return this.translate.get('pdf_download.primis').pipe(first());
      }),
      switchMap((res: string) => {
        this.pdfPrimisText = res;
        return this.translate.get('pdf_download.geopos').pipe(first());
      }),
      switchMap((res: string) => {
        this.pdfGeoposText = res;
        return this.translate.get('pdf_download.themes').pipe(first());
      }),
      switchMap((res: string) => {
        this.pdfThemPathsText = res;
        return this.translate.get('pdf_download.contains').pipe(first());
      }),
      tap((res: string) => {
        this.pdfContainsText = res;
        if (!!this.mapElement) {
          this.mapInitializer();
        }
      })
    ).subscribe();
  }

  titleAudioPresent() {
    return this.itin_current.attachments.some(({title_audio}) => title_audio === true);
  }

  playAudio(audioFileByte: string = null, attachmentId: number = null): void {
    if (this.titleAudioPlaying && !!attachmentId && !!audioFileByte) {
      this.resetAudioPlaying();
      this.attachmentAudioPlaying = attachmentId;
      this.audio = new Audio(audioFileByte);
      this.audio.play();
    } else if (!!this.attachmentAudioPlaying && attachmentId == null) {
      this.resetAudioPlaying();
      this.titleAudioPlaying = true;
      const index = this.itin_current.attachments.findIndex(({title_audio}) => title_audio === true);
      this.audio = new Audio(this.itin_current.attachments[index].file_byte);
      this.audio.play();
    } else if (this.titleAudioPlaying || !!this.attachmentAudioPlaying) {
      this.resetAudioPlaying();
    } else {
      if (audioFileByte) {
        this.attachmentAudioPlaying = attachmentId;
        this.audio = new Audio(audioFileByte);
      } else {
        this.titleAudioPlaying = true;
        const index = this.itin_current.attachments.findIndex(({title_audio}) => title_audio === true);
        this.audio = new Audio(this.itin_current.attachments[index].file_byte);
      }
      this.audio.play();
    }
  }

  poiImageUrl(dict: Poi) {
    for (const att of dict.attachments) {
      if (att.avatar) {
        return att.file_byte;
      }
    }
    return '../../../assets/home/no-picture.png';
  }

  async downloadPdf(): Promise<void> {
    const documentDefinition = {
      info: {
        title: this.itin_current.itin_name[this.current_lang],
        author: 'Primis Project',
        subject: this.itin_current.itin_name[this.current_lang],
        keywords: this.itin_current.themes.map(({name}) => name[this.current_lang]).join(', '),
        creator: 'Primis Project',
        producer: 'Primis Project',
      },
      content: [
        {
          text: 'Primis Project',
          style: ['header']
        },
        {
          text: this.pdfPrimisText,
          style: ['quote']
        },
        '\n',
        {
          text: this.itin_current.itin_name[this.current_lang],
          style: ['subheader']
        },
        this.itin_current.description[this.current_lang],
        '\n',
        {
          text: this.pdfContainsText,
          style: ['quote']
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          color: '#0097a7'
        },
        subheader: {
          fontSize: 15,
          bold: true,
          color: '#0097a7'
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 10
        }
      }
    };
    this.itin_current.pois.forEach(({poi_name, address, short_descr}) => {
      documentDefinition.content.push(
        '\n',
        {
          text: poi_name[this.current_lang],
          style: ['subheader']
        },
        {
          text: address,
          style: ['small', 'quote']
        },
        short_descr[this.current_lang]
      );
    });
    documentDefinition.content.push(
      '\n\n',
      {
        text: this.pdfGeoposText,
        style: ['subheader']
      },
      this.itin_current.geopos[0].name[this.current_lang],
      '\n',
      {
        text: this.pdfThemPathsText,
        style: ['subheader']
      },
      this.itin_current.themes.map(({name}) => name[this.current_lang]).join(', '),
    );
    const img = this.itin_current.attachments.find(({file_type}) => file_type === 'picture');
    if (img) {
      const imgSize: {width: number, height: number} = await this.getImgWidthHeight(img);
      const maxImgHeight = 258;
      const maxImgWidth = 450;
      const ratio = imgSize.width / imgSize.height;
      let width = maxImgWidth;
      let height = maxImgHeight;
      if (ratio <= 1.1) {
        width = maxImgHeight * ratio;
      } else {
        height = maxImgWidth / ratio;
      }
      documentDefinition.content.push(
        '\n\n',
        {
          image: img.file_byte,
          width: 516,
          height: 258,
        }
      );
    }

    const pdfDocGenerator = pdfmake.createPdf(documentDefinition, null, null, pdfFonts.pdfMake.vfs);
    pdfDocGenerator.getBlob((data) => {
      this.downloadFromBlob(data, this.itin_current.itin_name[this.current_lang]);
    });
  }

  private getImgWidthHeight(img: Attachments): Promise<{width: number, height: number}> {
    return new Promise ((resolved, _) => {
      const pic = new Image();
      pic.onload = () => {
        resolved({width: pic.width, height: pic.height});
      };
      pic.src = img.file_byte;
    });
  }

  getBase64FromUrl(urlImg: string) {
    const canvas = document.createElement('canvas');
    const img = new Image();
    img.src = urlImg;
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    img.onload = () => {
      ctx.drawImage(img, 0, 0);
    };
    return canvas.toDataURL('image/png');
  }

  private resetAudioPlaying() {
    this.audio.pause();
    this.titleAudioPlaying = false;
    this.attachmentAudioPlaying = null;
  }
}
